// IT_Outsources.tsx
import React, { useEffect, useState } from 'react';
import { motion , Variants, easeOut} from 'framer-motion';
import img from "../../assets/Best_IT_Outsourse_In_Noida.jpg";
import { Link } from 'react-router-dom';

// --- Define Animation Variants ---
export const fadeIn: Variants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6 },
  },
};

export const slideInLeft: Variants = {
  hidden: { opacity: 0, x: -50 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.7 },
  },
};

export const slideInRight: Variants = {
  hidden: { opacity: 0, x: 50 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.7 },
  },
};

export const staggerContainer: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.3,
    },
  },
};

export const cardVariant: Variants = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.5 },
  },
  hover: {
    scale: 1.05,
    transition: {
      type: "spring" as const, // TypeScript-safe
      stiffness: 300,
    },
  },
};

export const imageReveal: Variants = {
  hidden: { clipPath: "inset(0 100% 0 0)" },
  visible: {
    clipPath: "inset(0 0% 0 0)",
    transition: {
      duration: 1.2,
      ease: [0.42, 0, 0.58, 1], // "easeInOut"
    },
  },
};

export const textFadeInUp: Variants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.42, 0, 1, 1], // "easeOut"
    },
  },
};

export const rotateScale: Variants = {
  hidden: { opacity: 0, rotate: -5, scale: 0.9 },
  visible: {
    opacity: 1,
    rotate: 0,
    scale: 1,
    transition: {
      duration: 0.7,
      ease: [0.42, 0, 1, 1], // "easeOut"
    },
  },
};

const testimonials = [
  {
    name: 'Jane Doe, CEO of Tech Innovators',
    image: 'https://st2.depositphotos.com/3822073/7030/i/450/depositphotos_70301135-stock-photo-portrait-of-young-asian-student.jpg',
    quote:
      'Partnering with [ Nadezhda Venture Pvt. Ltd. ] for our IT outsourcing needs was a game-changer. Their expertise, communication, and dedication to our success exceeded all expectations. Highly recommended!',
  },
  {
    name: 'John Smith, COO of Global Solutions',
    image: 'https://i.pinimg.com/736x/9e/7e/6a/9e7e6a795a38ffa95345b0f3e41446a3.jpg',
    quote:
      'We saw significant cost savings and a boost in efficiency after outsourcing our IT infrastructure to them. Their team is professional, responsive, and truly an extension of our own.',
  },
  // Add more testimonials if needed
];


const ITOutsources: React.FC = () => {
  const [current, setCurrent] = useState(0);

   useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % testimonials.length);
    }, 6000); // 6 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="it-outsources-page min-h-screen bg-gray-50 text-gray-800">

      {/* 1. Hero Section */}
      <motion.section
        className="relative h-[450px] flex items-center justify-center text-center  text-white overflow-hidden"
        initial="hidden"
        animate="visible"
        variants={fadeIn}
      >
        <div className="absolute inset-0 z-0">
          {/* Background Image using standard <img> tag */}
          <img
            src={img} // Image path from public folder
            alt="Global IT Outsourcing"
            className="opacity-70 w-full h-full object-cover absolute inset-0" // Tailwind classes for fill behavior
            loading="eager" // Load immediately as it's above the fold
          />
          <div className="absolute inset-0 bg-black opacity-70"></div> {/* Dark overlay */}
        </div>
        <div className="z-10 max-w-4xl px-6">
          <motion.h1
            className="text-3xl md:text-4xl font-extrabold leading-tight mb-4 drop-shadow-lg text-orange-500"
            variants={textFadeInUp}
          >
            Empower Your Business with Strategic IT Outsourcing
          </motion.h1>
          <motion.p
            className="text-xl md:text-2xl mb-8 opacity-90 "
            variants={textFadeInUp}
            transition={{ delay: 0.3 }}
          >
            Unlock efficiency, innovation, and scalability by partnering with us for your IT needs.
          </motion.p>
          <motion.button
            
            variants={fadeIn}
            transition={{ delay: 0.6, duration: 0.5 }}
            whileHover={{ scale: 1.05, boxShadow: '0 10px 20px rgba(0,0,0,0.2)' }}
            whileTap={{ scale: 0.95 }}
          >
            <Link
    to="/contact"
    className="inline-block bg-blue-800 hover:bg-blue-600 text-white font-semibold py-3 px-6 rounded-md shadow-md transition-all duration-300"
  >
    Get a Free Consultation
  </Link>
          </motion.button>
        </div>
      </motion.section>

      {/* NEW: Why Choose IT Outsourcing? Section with image-based cards */}
      <motion.section
        className="py-16 px-8 bg-gray-100"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.4 }}
        variants={staggerContainer}
      >
        <motion.h2
          className="text-4xl font-bold text-center mb-12 text-blue-700"
          variants={fadeIn}
        >
          Why Choose IT Outsourcing?
        </motion.h2>
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 lg:grid-cols-3 gap-10">
          {/* Card 1: Cost Efficiency */}
          <motion.div
            className="bg-white p-6 rounded-lg shadow-xl hover:shadow-2xl transition-shadow duration-300 transform hover:-translate-y-2 flex flex-col items-center text-center border border-gray-200"
            variants={cardVariant}
            whileHover="hover"
          >
            <motion.div
              className="w-24 h-24 mb-4"
              initial={{ scale: 0.8 }}
              whileInView={{ scale: 1, transition: { duration: 0.5, ease: 'easeOut' } }}
              viewport={{ once: true }}
            >
              <img
                src="https://img.freepik.com/free-vector/programming-concept-illustration_114360-1351.jpg?semt=ais_hybrid&w=740"
                alt="Cost Efficiency"
                className="w-full h-full object-contain"
                loading="lazy"
              />
            </motion.div>
            <h3 className="text-xl font-semibold mb-2 text-gray-900">Cost Efficiency & Savings</h3>
            <p className="text-gray-600 text-sm">Reduce operational costs, minimize infrastructure investments, and convert fixed costs to variable costs.</p>
          </motion.div>

          {/* Card 2: Access to Global Talent */}
          <motion.div
            className="bg-white p-6 rounded-lg shadow-xl hover:shadow-2xl transition-shadow duration-300 transform hover:-translate-y-2 flex flex-col items-center text-center border border-gray-200"
            variants={cardVariant}
            whileHover="hover"
          >
            <motion.div
              className="w-24 h-24 mb-4"
              initial={{ scale: 0.8, rotate: -5 }}
              whileInView={{ scale: 1, rotate: 0, transition: { duration: 0.5, ease: 'easeOut', delay: 0.1 } }}
              viewport={{ once: true }}
            >
              <img
                src="https://png.pngtree.com/png-clipart/20230824/original/pngtree-web-app-developers-development-programming-picture-image_8455092.png"
                alt="Global Talent"
                className="w-full h-full object-contain"
                loading="lazy"
              />
            </motion.div>
            <h3 className="text-xl font-semibold mb-2 text-gray-900">Access to Global Talent & Expertise</h3>
            <p className="text-gray-600 text-sm">Leverage a vast pool of specialized skills and cutting-edge technologies without internal hiring complexities.</p>
          </motion.div>

          {/* Card 3: Focus on Core Business */}
          <motion.div
            className="bg-white p-6 rounded-lg shadow-xl hover:shadow-2xl transition-shadow duration-300 transform hover:-translate-y-2 flex flex-col items-center text-center border border-gray-200"
            variants={cardVariant}
            whileHover="hover"
          >
            <motion.div
              className="w-24 h-24 mb-4"
              initial={{ scale: 0.8 }}
              whileInView={{ scale: 1, transition: { duration: 0.5, ease: 'easeOut', delay: 0.2 } }}
              viewport={{ once: true }}
            >
              <img
                src="https://www.pngitem.com/pimgs/m/112-1128181_software-development-png-transparent-images-software-development-images.png"
                alt="Core Business Focus"
                className="w-full h-full object-contain"
                loading="lazy"
              />
            </motion.div>
            <h3 className="text-xl font-semibold mb-2 text-gray-900">Focus on Core Business</h3>
            <p className="text-gray-600 text-sm">Delegate non-core IT functions to experts, allowing your team to concentrate on strategic initiatives.</p>
          </motion.div>

          {/* Card 4: Scalability & Flexibility */}
          <motion.div
            className="bg-white p-6 rounded-lg shadow-xl hover:shadow-2xl transition-shadow duration-300 transform hover:-translate-y-2 flex flex-col items-center text-center border border-gray-200"
            variants={cardVariant}
            whileHover="hover"
          >
            <motion.div
              className="w-24 h-24 mb-4"
              initial={{ scale: 0.8, y: 10 }}
              whileInView={{ scale: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut', delay: 0.3 } }}
              viewport={{ once: true }}
            >
              <img
                src="https://static.vecteezy.com/system/resources/previews/009/298/359/non_2x/3d-illustration-of-web-development-png.png"
                alt="Scalability"
                className="w-full h-full object-contain"
                loading="lazy"
              />
            </motion.div>
            <h3 className="text-xl font-semibold mb-2 text-gray-900">Scalability & Flexibility</h3>
            <p className="text-gray-600 text-sm">Easily scale IT resources up or down based on your business demands, ensuring agility and responsiveness.</p>
          </motion.div>

          {/* Card 5: Risk Mitigation */}
          <motion.div
            className="bg-white p-6 rounded-lg shadow-xl hover:shadow-2xl transition-shadow duration-300 transform hover:-translate-y-2 flex flex-col items-center text-center border border-gray-200"
            variants={cardVariant}
            whileHover="hover"
          >
            <motion.div
              className="w-24 h-24 mb-4"
              initial={{ scale: 0.8, rotate: 5 }}
              whileInView={{ scale: 1, rotate: 0, transition: { duration: 0.5, ease: 'easeOut', delay: 0.4 } }}
              viewport={{ once: true }}
            >
              <img
                src="https://png.pngtree.com/png-vector/20200312/ourmid/pngtree-modern-flat-design-concept-of-programmers-at-work-concept-software-development-png-image_2157875.jpg"
                alt="Risk Mitigation"
                className="w-full h-full object-contain"
                loading="lazy"
              />
            </motion.div>
            <h3 className="text-xl font-semibold mb-2 text-gray-900">Risk Mitigation</h3>
            <p className="text-gray-600 text-sm">Reduce risks associated with technology changes, security threats, and compliance issues.</p>
          </motion.div>

          {/* Card 6: Innovation & Competitive Edge */}
          <motion.div
            className="bg-white p-6 rounded-lg shadow-xl hover:shadow-2xl transition-shadow duration-300 transform hover:-translate-y-2 flex flex-col items-center text-center border border-gray-200"
            variants={cardVariant}
            whileHover="hover"
          >
            <motion.div
              className="w-24 h-24 mb-4"
              initial={{ scale: 0.8 }}
              whileInView={{ scale: 1, transition: { duration: 0.5, ease: 'easeOut', delay: 0.5 } }}
              viewport={{ once: true }}
            >
              <img
                src="https://img.freepik.com/premium-vector/man-working-with-computer-office-desk-flat-design-illustration_634662-19.jpg" // Using a generic image, replace if you have a specific one for innovation
                alt="Innovation"
                className="w-full h-full object-contain"
                loading="lazy"
              />
            </motion.div>
            <h3 className="text-xl font-semibold mb-2 text-gray-900">Innovation & Competitive Edge</h3>
            <p className="text-gray-600 text-sm">Gain access to the latest technological advancements and stay ahead of the curve.</p>
          </motion.div>
        </div>
      </motion.section>

      {/* 3. Our IT Outsourcing Services Section (Tabbed/Categorized) */}
      <motion.section
        className="py-16 px-8 bg-white"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={fadeIn}
      >
        <motion.h2
          className="text-4xl font-bold text-center mb-12 text-blue-700"
          variants={fadeIn}
        >
          Our Comprehensive IT Outsourcing Services
        </motion.h2>
        <div className="max-w-7xl mx-auto">
          {/* Tab Navigation (example - you'll need state management for actual tabs) */}
          <div className="flex justify-center space-x-4 mb-10 overflow-x-auto pb-4">
            {['Software Development', 'IT Infrastructure', 'Cybersecurity', 'Cloud Services', 'Managed IT Support'].map((service, index) => (
              <motion.button
                key={service}
                className="py-3 px-6 rounded-full text-lg font-semibold bg-blue-100 text-blue-700 hover:bg-blue-200 transition-colors duration-200 whitespace-nowrap"
                // Add active state styling
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0, transition: { delay: index * 0.1 } }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.97 }}
              >
                {service}
              </motion.button>
            ))}
          </div>

          {/* Service Content Display (example for one tab) */}
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <motion.div
              className="md:order-2"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.5 }}
              variants={slideInRight}
            >
              {/* Using standard <img> tag */}
              <img
                src="https://nvassistant.com/Assets/allimages/front-end-img/Icon/nadezhda_ventures_rectangular_angular.png" // Image path from public folder
                alt="Software Development Outsourcing"
                className="rounded-lg shadow-xl w-[400px] h-[400px]" // Responsive width, auto height
                loading="lazy" // Lazy load images not in the initial viewport
              />
            </motion.div>
            <motion.div
              className="md:order-1"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.5 }}
              variants={slideInLeft}
            >
              <h3 className="text-3xl font-bold mb-4 text-gray-900">Custom Software Development</h3>
              <p className="text-lg text-gray-700 mb-6">
                From concept to deployment, our expert teams build robust, scalable, and innovative software solutions tailored to your unique business needs. We specialize in web, mobile, and enterprise application development.
              </p>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <motion.li variants={textFadeInUp}>Web Application Development</motion.li>
                <motion.li variants={textFadeInUp}>Mobile App Development (iOS & Android)</motion.li>
                <motion.li variants={textFadeInUp}>Enterprise Software Solutions</motion.li>
                <motion.li variants={textFadeInUp}>UI/UX Design & Prototyping</motion.li>
                <motion.li variants={textFadeInUp}>Quality Assurance & Testing</motion.li>
              </ul>
             <motion.div
  whileHover={{ y: -3 }}
  whileTap={{ scale: 0.98 }}
>
  <Link
    to="/Full_Stack_Developer_In_Noida"
    className="mt-8 inline-block bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-md shadow-md transition-all duration-300"
  >
    Learn More about Software Development
  </Link>
</motion.div>
            </motion.div>
          </div>
          {/* Repeat similar structure for other service categories, changing image and text */}
        </div>
      </motion.section>

      {/* NEW SECTION: Image Display (replacing "Our Process") */}
      <motion.section
        className="py-16 px-8 bg-gradient-to-br from-blue-50 to-indigo-100"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={staggerContainer}
      >
        <motion.h2
          className="text-4xl font-bold text-center mb-12 text-blue-700"
          variants={fadeIn}
        >
          Our Expertise in Action
        </motion.h2>
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Image 1 from old process step 1 */}
          <motion.div
            className="flex flex-col items-center p-4 bg-white rounded-lg shadow-md"
            variants={cardVariant} // Re-using card variant for consistency
            whileHover="hover"
          >
            <img
              src="https://img.freepik.com/free-vector/programming-concept-illustration_114360-1351.jpg?semt=ais_hybrid&w=740"
              alt="Discovery & Consultation"
              className="rounded-lg w-full h-48 object-cover mb-4"
              loading="lazy"
            />
            <p className="text-lg font-semibold text-gray-800 text-center">In-depth Consultation & Planning</p>
          </motion.div>

          {/* Image 2 from old process step 2 */}
          <motion.div
            className="flex flex-col items-center p-4 bg-white rounded-lg shadow-md"
            variants={cardVariant}
            whileHover="hover"
          >
            <img
              src="https://png.pngtree.com/png-clipart/20230824/original/pngtree-web-app-developers-development-programming-picture-image_8455092.png"
              alt="Solution Design"
              className="rounded-lg w-full h-48 object-cover mb-4"
              loading="lazy"
            />
            <p className="text-lg font-semibold text-gray-800 text-center">Strategic Solution Design</p>
          </motion.div>

          {/* Image 3 from old process step 3 */}
          <motion.div
            className="flex flex-col items-center p-4 bg-white rounded-lg shadow-md"
            variants={cardVariant}
            whileHover="hover"
          >
            <img
              src="https://www.pngitem.com/pimgs/m/112-1128181_software-development-png-transparent-images-software-development-images.png"
              alt="Team Assembly"
              className="rounded-lg w-full h-48 object-cover mb-4"
              loading="lazy"
            />
            <p className="text-lg font-semibold text-gray-800 text-center">Expert Team Assembly</p>
          </motion.div>

          {/* Image 4 from old process step 4 */}
          <motion.div
            className="flex flex-col items-center p-4 bg-white rounded-lg shadow-md"
            variants={cardVariant}
            whileHover="hover"
          >
            <img
              src="https://static.vecteezy.com/system/resources/previews/009/298/359/non_2x/3d-illustration-of-web-development-png.png"
              alt="Execution & Delivery"
              className="rounded-lg w-full h-48 object-cover mb-4"
              loading="lazy"
            />
            <p className="text-lg font-semibold text-gray-800 text-center">Seamless Execution & Delivery</p>
          </motion.div>

          {/* Image 5 from old process step 5 */}
          <motion.div
            className="flex flex-col items-center p-4 bg-white rounded-lg shadow-md"
            variants={cardVariant}
            whileHover="hover"
          >
            <img
              src="https://png.pngtree.com/png-vector/20200312/ourmid/pngtree-modern-flat-design-concept-of-programmers-at-work-concept-software-development-png-image_2157875.jpg"
              alt="Monitoring & Optimization"
              className="rounded-lg w-full h-48 object-cover mb-4"
              loading="lazy"
            />
            <p className="text-lg font-semibold text-gray-800 text-center">Continuous Monitoring & Optimization</p>
          </motion.div>

          {/* Image 6 from old process step 5 */}
          <motion.div
            className="flex flex-col items-center p-4 bg-white rounded-lg shadow-md"
            variants={cardVariant}
            whileHover="hover"
          >
            <img
              src="https://img.freepik.com/premium-vector/man-working-with-computer-office-desk-flat-design-illustration_634662-19.jpg"
              alt="Successful Apps Delivered"
              className="rounded-lg w-full h-48 object-cover mb-4"
              loading="lazy"
            />
            <p className="text-lg font-semibold text-gray-800 text-center">Successful Apps Delivered</p>
          </motion.div>
        </div>
      </motion.section>


      {/* 5. Client Testimonials/Success Stories Section */}
      <motion.section
      className="py-20 px-4 md:px-12 bg-gray-100"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.6 }}
    >
      <h2 className="text-4xl font-bold text-center mb-12 text-blue-700">
        What Our Clients Say
      </h2>

      <div className="relative max-w-6xl mx-auto">
        {testimonials.map((testimonial, index) => (
          <motion.div
            key={index}
            className={`flex flex-col md:flex-row items-center gap-8 transition-opacity duration-500 absolute w-full ${
              index === current ? 'opacity-100 relative' : 'opacity-0 absolute'
            }`}
            initial={{ opacity: 0 }}
            animate={{ opacity: index === current ? 1 : 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="flex-shrink-0 w-32 h-32 rounded-full overflow-hidden shadow-lg">
              <img
                src={testimonial.image}
                alt={testimonial.name}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="text-center md:text-left max-w-2xl">
              <p className="text-lg italic text-gray-700 mb-4">"{testimonial.quote}"</p>
              <p className="font-semibold text-blue-600">{testimonial.name}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.section>

      {/* 6. Call to Action Section
      <motion.section
        className="py-20 px-8 bg-blue-600 text-white text-center"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
        variants={fadeIn}
      >
        <motion.h2
          className="text-4xl md:text-5xl font-extrabold mb-6"
          variants={textFadeInUp}
        >
          Ready to Transform Your IT Operations?
        </motion.h2>
        <motion.p
          className="text-xl md:text-2xl mb-10 opacity-90"
          variants={textFadeInUp}
          transition={{ delay: 0.3 }}
        >
          Let&apos;s discuss how our tailored IT outsourcing solutions can drive your business forward.
        </motion.p>
        <motion.button
          className="bg-green-500 hover:bg-green-600 text-white font-bold py-4 px-10 rounded-full shadow-xl transform transition duration-300 ease-in-out hover:scale-105 text-xl"
          variants={fadeIn}
          transition={{ delay: 0.6, duration: 0.5 }}
          whileHover={{ scale: 1.05, boxShadow: '0 12px 24px rgba(0,0,0,0.3)' }}
          whileTap={{ scale: 0.95 }}
        >
          Request a Free Quote Today
        </motion.button>
      </motion.section> */}

    </div>
  );
};

export default ITOutsources;